<div class="container text-center mt-5">
    <img src="unauthorized.png" alt="Acceso no autorizado" style="max-width:200px; margin-bottom:20px;">
    <h1 class="text-danger">Acceso no autorizado</h1>
    <p class="lead">No tienes permisos para ver esta página.</p>
    <img src="lock.png" alt="Lock" style="max-width:100px; margin-top:20px;">
    <div class="mt-4">
        <a [routerLink]="['/']" class="btn btn-primary">Volver al inicio</a>
    </div>
</div>